import {ApiError} from './apiError';

export class ProUpgradeRequiredError extends ApiError {
  constructor(message?: string) {
    super(message || '402 Pro upgrade required');
  }
}
